import { t } from 'i18next'
import { toJS } from 'mobx'
import { IoSaveOutline } from 'react-icons/io5'

export const SaveButtonHandlerTask = ({ buttons, crudContext }) => {
    buttons.save = {
        sort: 900,
        icon: <IoSaveOutline style={{ fontSize: 19 }} />,
        depFn: ({ crudContext }) => {
            return (
                crudContext.formContext.isEditable &&
                ((crudContext.formContext.values?.id > 0 &&
                    crudContext.accessFn({
                        accessMode: 'update',
                        accessItem: ({
                            ...toJS(crudContext.formContext.values),
                            _original: toJS(crudContext.formContext.initialValues),
                        }),
                        crudContext: crudContext,
                    })) ||
                    (crudContext.accessFn({
                        accessMode: 'create',
                        accessItem: ({
                            ...toJS(crudContext.formContext.values),
                            _original: toJS(crudContext.formContext.initialValues),
                        }),
                        crudContext: crudContext,
                    }) &&
                        !crudContext.formContext.values?.id))
            )
        },
        get loading() {
            return crudContext.formContext.isLoading
        },
        type: 'primary',
        size: 'middle',
        onClick: () => {
            if (crudContext?.formComposerContext) crudContext.formComposerContext.submit()
            else crudContext.formContext.submit()
        },
        label: t('Save', { ns: 'Core' }),
    }
}
